import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-614ab187"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-administrator-dashboard-root-posts" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box__headline" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Objave ")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "box__list"
}
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "message" }
const _hoisted_8 = {
  key: 0,
  class: "preview"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "date-and-action" }
const _hoisted_11 = { class: "date" }
const _hoisted_12 = {
  key: 1,
  class: "box__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.posts.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts, (post, key) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: post.id
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, " #" + _toDisplayString(key + 1) + " - " + _toDisplayString(post.user.content.name) + " " + _toDisplayString(post.user.content.surname), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(post.content.message), 1),
                  (post.content.url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("iframe", {
                          width: "100%",
                          src: _ctx.getVideoURL(post.content.url)
                        }, null, 8, _hoisted_9)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("strong", null, "Datum: " + _toDisplayString(_ctx.moment(post.created_at).format('DD.MM.YYYY.')), 1)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, " Nema podataka... "))
    ])
  ]))
}